import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { NgForm } from "@angular/forms";
import { QuoteService } from "../../quote/services/quote.service";
import { MonthType } from "../../shared/models/month.type.interface";
import { Customer } from "../../shared/models/customer.interface";
import { CustomerSummary, CustomerSummaryResult } from "../models/customer.summary.interface";
import { ReportService } from "../services/report.service";
import { FileService } from "../../shared/services/file.service";
import { AbstractBiditComponent } from "../../shared/controls/abstract.bidit.component";
import { DeviceDetectorService } from "ngx-device-detector";
import { AbstractReportComponent } from "../abstract.report.component";
import { Component, Inject, LOCALE_ID, OnInit } from "@angular/core";

export interface CustomerSummaryParameterData {
  customerSummary: CustomerSummary;

  customers: Customer[];
  years: number[];
  months: MonthType[];
}

@Component({
  selector: 'app-customer-summary',
  templateUrl: './customer.summary.component.html',
  styleUrls: ['./customer.summary.component.scss']
})
export class CustomerSummaryComponent extends AbstractReportComponent implements OnInit {

  report: CustomerSummaryResult = null;
  parameters: CustomerSummary = {
    customer_ID: null,
    displayFormat: true,
    year: (new Date()).getFullYear(),
    startMonth: 0,
    endMonth: 11
  } as CustomerSummary;

  customer: Customer;
  displayFormat: string;

  customers: Customer[];

  constructor(@Inject(LOCALE_ID) locale: string,
    deviceDetectorService: DeviceDetectorService,
    dialog: MatDialog, private quoteService: QuoteService,
    private reportService: ReportService, private fileService: FileService) {
    super(locale, dialog, deviceDetectorService);
  }

  ngOnInit() {
    this.quoteService.getCustomers()
      .subscribe({
        next: (data) => {
          this.customers = data;
          this.showParameters();
        },
        error: (error: string) => this.onError(error)
      });


    this.setupDates();
  }

  renderReport() {
    this.getReportFormat()
      .subscribe(formatData => {
        if (formatData == null) return;

        this.isRequesting = true;
        this.reportService.getCustomerSummaryExport(this.parameters, formatData.format, formatData.locale)
          .subscribe({
            next: (data) => {
              this.isRequesting = false;
              this.fileService.downloadFile(data, 'CustomerSummary' + formatData.extension);
            },
            error: (error: string) => this.onError(error)
          });
    });
  }

  showParameters() {
    const dialogRef = this.dialog.open(CustomerSummaryParameterDialog, {
      width: '550px',
      data: {
        customerSummary: (<any>Object).assign({}, this.parameters),

        customers: this.customers,
        years: this.years,
        months: this.months
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        this.parameters = result.customerSummary as CustomerSummary;
        this.reportService.setupParameters(this.parameters);

        this.customer = this.customers.find(s => s.customer_ID == this.parameters.customer_ID);
        this.displayFormat = (this.parameters.displayFormat ? 'Contacts & Quotes' : 'Contacts Only');

        this.reportService.getCustomerSummaryReport(result.customerSummary)
          .subscribe({
            next: (data) => {
              this.report = data;
            },
            error: (error: string) => this.onError(error)
          });
      }
    });
  }
}

@Component({
  selector: 'customer.summary.parameter.dialog',
  templateUrl: 'customer.summary.parameter.dialog.html',
})
export class CustomerSummaryParameterDialog {

  constructor(
    public dialogRef: MatDialogRef<CustomerSummaryParameterDialog>,
    @Inject(MAT_DIALOG_DATA) public data: CustomerSummaryParameterData) { }

  runReport(form: NgForm): void {
    if (form.valid) {
      this.dialogRef.close(this.data);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
